export const getIsMobileByUA = (userAgent) => {
  const isMobileButNotAndroidByUserAgent =
    /webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isAndroidMobile = /Android/.test(userAgent) && /Mobile/.test(userAgent);

  return isMobileButNotAndroidByUserAgent || isAndroidMobile;
};

export const getIsTabletByUA = (userAgent) => {
  const isIpad =
    /iPad/i.test(userAgent) ||
    typeof window === 'undefined' ||
    // iPad Pro
    (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document);
  const isAndroidTablet =
    /Android/.test(userAgent) && !/Mobile/.test(userAgent);

  return isIpad || isAndroidTablet;
};
